import { ApiResult } from 'interfaces/APITypes';
import { GuestPayload, LoginPayload } from 'interfaces/LoginPayload';

import { makeRequest, mytoverInstance } from './client';

export const signin = async (payload: LoginPayload): Promise<ApiResult> => {
  await mytoverInstance.get('/sanctum/csrf-cookie');
  return makeRequest(mytoverInstance.post('/login', payload));
};

export const signInAsGuest = async (payload: GuestPayload): Promise<ApiResult> => {
  await mytoverInstance.get('/sanctum/csrf-cookie');
  return makeRequest(mytoverInstance.post('/guest_login', payload));
};

export const checkQrAccess = async (token: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/units/${token}/qr_access`));
};

export const signout = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post('/logout'));
};
